import script from "./AgregarCepaDialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgregarCepaDialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./AgregarCepaDialogComponent.vue?vue&type=style&index=0&id=f46c3814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46c3814"]])

export default __exports__